import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';
import {User} from '../../_models/index';
import {MatDialog, MatDialogConfig,} from '@angular/material/dialog';
import {LoginHelper} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {FormBuilder} from "@angular/forms";
import {AssessmentService} from "../../_services/assessment.service";
import {forkJoin} from "rxjs";
import {AssessmentUserAnswersComponent} from "../assessmentUserAnswers/assessmentUserAnswers.component";

@Component({
    standalone: false,
  selector: "assessmentAnswers-component",
  templateUrl: 'assessmentAnswers.component.html',
  styleUrls: ['./assessmentAnswers.component.scss'],
})

export class AssessmentAnswersComponent implements OnInit {
  api = window.location.origin;
  items: any[];
  assessmentId: number = null;
  assessments = [];
  quiz: any;
  tenantName: string;
  answers: any[];
  columns: any[] = [];
  token = LoginHelper.getFileToken();
  users: User[];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public assessmentService: AssessmentService) {

  }


  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    forkJoin(
      this.assessmentService.getAllAssessments(),
      this.assessmentService.getAssessmentResults(),
      this.userService.getAllShort()
    ).subscribe(t => {
      this.route.params.subscribe(p => {
        this.assessmentId = p['id'];
        this.assessments = t[0];
        this.quiz = this.assessments.find(t => t.id == this.assessmentId);
        this.answers = t[1].filter(t => t.assessmentId == this.assessmentId);
        this.answers.forEach(a => a.results = JSON.parse(a.answers));
        this.users = t[2];
      })
    });
  }

  getFullName(userId)
  {
    const user = this.users.find(u => u.userId == userId);
    if (!user) return "";
    if (user.firstName != null
      || user.lastName != null){
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  open(item){
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '98%',
      height: '90vh',
      data: {
        quiz: this.quiz,
        answers: item
      }
    };

    const dialogRef = this.dialog.open(AssessmentUserAnswersComponent, config);
  }

}
